




















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IPubPropertyCategory, LeadLightModel } from '@immosparrow/cockpit-api-v2'

@Component
export default class LeadItem extends Vue {
  @Prop()
  lead!: LeadLightModel;

  get getPropertyTypes (): IPubPropertyCategory[] {
    return this.$store.getters.propertyTypes
  }

  get propertyType () {
    const id = this.lead.publication?.primaryInfo?.basicInfo?.propertyTypeId
    const names: string[] = []
    this.getPropertyTypes.forEach(category => {
      const propName = category.propertyTypes?.find(type => {
        return type.id === id
      })
      if (propName?.name && !names.includes(propName.name)) {
        names.push(propName.name)
      }
    })
    return (names.toString().match(/[A-Z][a-z]+/g))?.join(' ')
  }

  get rooms () {
    return this.lead.publication?.primaryInfo?.layout?.rooms?.roomCount?.value || 'n/a'
  }

  get livingArea () {
    return this.lead.publication?.primaryInfo?.layout?.size?.areaLiving?.value
  }

  get propertyArea () {
    return this.lead.publication?.primaryInfo?.layout?.size?.areaProperty?.value
  }

  get constructionYear () {
    return this.lead.publication?.primaryInfo?.basicInfo?.builtYearCalculated || 'n/a'
  }

  get renovationYear () {
    return this.lead.publication?.primaryInfo?.basicInfo?.renovationYearCalculated || 'n/a'
  }
}
